// extracted by mini-css-extract-plugin
export const root = "SignupBlock-module--root--27Tqg";
export const title = "SignupBlock-module--title--3SGxu";
export const content = "SignupBlock-module--content--30ak3";